import { SessionEvent } from '../ISessionEvent';

export class SessionStartedEvent extends SessionEvent {
  constructor() {
    super('session-started', {});
  }
}
